<footer class="footer">
  <div class="wrapper wrap">
    <div class="container">
      <div class="links">
    
        <ul>
          <li>
            <a href="https://www.westberks.gov.uk/accessibility">Accessibility</a>
          </li>
          <li>
            <a href="https://www.westberks.gov.uk/contactus">Contact Us</a>
          </li>
          <li>
            <a href="https://www.westberks.gov.uk/cookies">Cookies</a>
          </li>
          <li>
            <a href="https://www.westberks.gov.uk/outofhoursemergencies">Out Of Hours
              Emergencies</a>
          </li>
          <li>
            <a href="https://www.westberks.gov.uk/privacypolicy">Privacy Policy</a>
          </li>
          <li>
            <a href="https://www.westberks.gov.uk/article/35293/Council-Offices-Market-Street-Newbury-RG14-5LD">Council
              Offices
              , Market Street , Newbury , RG14 5LD </a>
          </li>
        </ul>
  

      </div>
      <div class="social">
        <img class="logo" src="/assets/images/logo-white.png" alt="The West Berkshire Council logo">
        <ul class="p-0 m-0">
          <li>
            <a href="https://www.facebook.com/westberkshire" aria-label="Facebook pages for West Berkshire">
              <fa-icon [icon]="faFacebookF"></fa-icon>
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/westberkshire/" aria-label="West Berkshire Council on Instagram">
              <fa-icon [icon]="faInstagram"></fa-icon>
            </a>
          </li>
          <li>
            <a href="http://www.youtube.com/c/westberkshire" aria-label="The official West Berkshire Council Youtube Channel">
              <fa-icon [icon]="faYoutube"></fa-icon>
            </a>
          </li>
          <li>
            <a href="https://pages.info.westberks.gov.uk/p/subscribe-west-berkshire" aria-label="A link to sign up to receive e-bulletins from West Berkshire Council">
              <fa-icon [icon]="faEnvelope"></fa-icon>
            </a>
          </li>
          <li>
            <a href="https://www.tiktok.com/@westberkshire?lang=en" aria-label="A link to West Berkshire Council on TikTok">
              <fa-icon [icon]="faTikTok"></fa-icon>
            </a>
          </li>
        </ul>
      </div>
    </div>

  </div>
</footer>